// Import and register all your controllers

import { application } from "./application"

// Import controllers here as they are created
import CheckboxSelectionController from "./checkbox_selection_controller"
application.register("checkbox-selection", CheckboxSelectionController)

import NoteModalController from "./note_modal_controller"
application.register("note-modal", NoteModalController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import RaceItemsController from "./race_items_controller"
application.register("race-items", RaceItemsController)

import TeamPickerController from "./team_picker_controller"
application.register("team-picker", TeamPickerController)

import ToggletipController from "./toggletip_controller"
application.register("toggletip", ToggletipController)

import TicketGuardianController from "./ticket_guardian_controller"
application.register("ticket-guardian", TicketGuardianController)
